<template>

  <div class="content blockW  usercenter">
    <div class="main-box screen-first-con">
    <!-- <div class="main-box"> -->
      <!--<h1 class="slogan">云游无界一触即发</h1>-->
      <div class="userBox">
        <div class="userDetail">
          <img src="~assets/img/1.png" />
          <p class="status">ID：{{userInfo&& userInfo.chargeAccount ? userInfo.chargeAccount : userInfo.freeAccount}}</p>
          <!--<span class="statusBtn">绑定</span>-->
        </div>
        <div class="userDetail">
          <img src="~assets/img/2.png" />
          <p class="status">{{userInfo ? userInfo.mobile : '未绑定'}}</p>
          <span class="statusBtn" id="resetBtn" @click="bindSet(2)">重置</span>
        </div>
        <div class="userDetail" >
          <img src="~assets/img/3.png" />
          <p class="status">{{ $store.state.user && $store.state.user.wxOpenid ? '已绑定' : '未绑定' }}</p>
          <span class="statusBtn weixinBtn" @click="bindSet(3)">
            {{ $store.state.user && $store.state.user.wxOpenid ? '解绑' : '绑定' }}
          </span>
        </div>
        <div class="userDetail">
          <img src="~assets/img/4.png" />
          <p class="status">{{ $store.state.user&& $store.state.user.qqUnionid ? '已绑定' : '未绑定' }}</p>
          <span class="statusBtn qqBtn" @click="bindSet(1)">
            {{ $store.state.user && $store.state.user.qqUnionid ? '解绑' : '绑定' }}
          </span>
        </div>
      </div>
    </div>
    <!-- 微信的绑定 -->
    <!-- <Dialog :show.sync="setDialog" width="615px" top="123px" custom-class="set_dialog" > -->
    <Dialog
      :show.sync="setDialog"
      width="615px"
      height="295px"
      custom-class="wx_dialog set_dialog"
    >
      <div class="bind_setting">
        <div class="img">
          <iframe
            name="bondwxFrame"
            :src="wxQrcodeUrl"
            
            style="z-index:999"
            frameborder="0"
            scrolling="no"
          />
        </div>

        <!-- <iframe name="bondwxFrame" :src="wxQrcodeUrl" width="150px" height="150px" style="z-index:999" frameborder="0" scrolling="no" /> -->

        <p style="font-size:20px;position:absolute;bottom:50px;left:0;right:0;text-align:center">扫码绑定</p>
      </div>
    </Dialog>
    <!-- qq的绑定 -->
    <!-- <Dialog
      v-if="bindQQDialogVisible"
      custom-class="bindqq-dialog"
      :show.sync="bindQQDialogVisible"
      width="492px"
      @close="closeQQDialog"
    >
      <div class="bindqq-box">
        <iframe
          id="qqFrame"
          name="qqFrame"
          :src="qqQrcodeUrl"
          width="100%"
          height="9999px"
          style="z-index:999;"
          frameborder="0"
          scrolling="no"
        />
      </div>
    </Dialog> -->

    <!-- 解除绑定 -->
    <Dialog
      :show.sync="unboundWechatDialogVisible"
      width="615px"
      top="123px"
      custom-class="set_dialog"
      v-if="unboundWechatDialogVisible"
    >
      <div class="bind_setting unbind_dialog">
        <p>{{title}}</p>
        <div class="bind_info">
          <img :src="bindUrl" alt />
          <p>{{bindName}}</p>
          <p class="btn" @click="unbind">解除绑定</p>
        </div>
        <div v-if="unbindDialog">
          <p>扫码绑定</p>
        </div>
      </div>
    </Dialog>
    <!-- 解绑提醒 -->
    <Dialog :show.sync="unbindDialog" width="615px" top="123px" custom-class="set_dialog">
      <div class="bind_setting unbind_dialog">
        <p>{{title}}</p>
        <!-- <p>{{title}}自绑定之日起30天内无法解绑，请在**日后操作解绑</p> -->
        <p>{{title}}{{msg}}</p>
        <div class="bind_info">
          <p class="btn">解除绑定</p>
        </div>
      </div>
    </Dialog>
    <!-- 重置信息 -->
    <Dialog
      v-if="chooseResetTypeVisible"
      custom-class="choose-reset-dialog"
      :show.sync="chooseResetTypeVisible"
      width="615px"
      top="90px"
    >
      <div class="content">
        <div class="detailOperate" id="resetOption" >
          <p class="operateTitle">重置</p>
          <div >
            <span class="detailOperatebtn resetPass" @click="chooseResetType('password')">重置登录密码 </span>
          </div>
          <div style="margin:0 auto">
            <span class="detailOperatebtn resetPhone" @click="chooseResetType('mobile')">重置绑定手机 </span>
          </div>
          <div class="close detailOperateCloseBtn" @click="chooseResetTypeVisible = false">取消</div>
        </div>
        <!-- <span @click="chooseResetType('password')">重置登录密码</span>
        <span @click="chooseResetType('mobile')">重置绑定手机号</span> -->
      </div>
    </Dialog>
    <!-- 重置手机号 -->
    <resetPhone :dialog-visible.sync="showPhoneDialog" />
    <!-- 重置密码 -->
    <ResetPwdDialog :dialog-visible.sync="resetPwdDialogVisible" />
  </div>
</template>

<script>
import ResetPwdDialog from "./resetPwdDialog";
import resetPhone from "./resetPhone";
import rules from "@/utils/rules";
export default {

  name: "user",
  components: {
    ResetPwdDialog,
    resetPhone
  },
  data() {
    return {
      rules,
      setDialog: false,
      unbindDialog: false,
      title: "",
      editPortrait: false,
      chooseResetTypeVisible: false,
      showPhoneDialog: false,
      resetPwdDialogVisible: false,
      user: {},
      changeUserInfoForm: {},
      wxQrcodeUrl: "",
      qqQrcodeUrl: "",
      unboundWechatDialogVisible: false,
      bindQQDialogVisible: false,
      isBindQQ: false,
      bindType: null,
      msg: "",
      bindUrl: "",
      bindName: "",
      windowOpen: null
    };
  },
  computed: {
    userInfo() {
      const { user } = this.$store.state;
      if (!user) {
        
        return;
      } else {
      }
      return user;
    }
  },
  mounted() {
    this.$store.dispatch("getMyInfo");
    this.$nextTick(() =>{
      screenFirst();
      // this.screenFirst();
    });

  },

  methods: {
    bindSet(type) {
      this.bindType = type;
      switch (type) {
        case 1:
          this.title = "QQ";
          this.bindQQ();
          // this.bindQQDialogVisible = true;
          break;
        case 2:
          this.title = "手机";
          this.chooseResetTypeVisible = true;
          break;
        case 3:
          this.title = "微信";
          // this.setDialog = true;
          this.wechat();
          break;
        case 4:
          this.$toast("敬请期待");
          break;
      }
    },
    wechat() {
      // this.unboundFlag = 'wechat'
      if (this.$store.state.user.wxOpenid) {
        this.unboundWechatDialogVisible = true;
        this.bindUrl = this.$store.state.user.wxHeadImgUrl;
        this.bindName = this.$store.state.user.wxNickName;
      } else {
        this.setDialog = true;
        this.$http.bind_get_wx_qrcode().then(res => {
          this.wxQrcodeUrl = res.data;
        });
      }
    },
    bindQQ() {
      // this.unboundFlag = "QQ";
      if (this.$store.state.user.qqUnionid) {
        this.bindUrl = this.$store.state.user.qqHeadImgUrl;
        this.bindName = this.$store.state.user.qqNickName;
        this.unboundWechatDialogVisible = true;
      } else {
        // this.bindQQDialogVisible = true;
        let that = this;
        that.$http.bind_get_qq_qrcode().then(res => {
          that.qqQrcodeUrl = res.data;
          this.windowOpen = window.open(this.qqQrcodeUrl,"_self");
          setTimeout(() => {
            that.isBindQQ = true;
          }, 1500);
          that.listeningQQCallbackTimer = setInterval(() => {
            let code = window.localStorage.getItem("qqCode");
            if (code) {
              that.bindQQDialogVisible = false;
              that.bindQQCallback(code);
              window.localStorage.removeItem("qqCode");
              clearInterval(this.listeningQQCallbackTimer);
            }
          }, 1000);
        });
      }
    },
    bindQQCallback(code) {
      this.$http.bind_qq({ code }).then(res => {
        this.$toast("绑定成功!");
        // window.close();
        // this.windowOpen.close();
        this.$store.dispatch("getMyInfo");
      });
    },
    // QQ和微信解绑
    unbind() {
      this.unbindDialog = false;
      if (this.bindType === 3) {
        const params = {
          customer: {
            customer: this.$store.state.user.nickname
          }
        };
        this.$http.release_wx(null).then(res => {
          if (res.code !== 600) {
            this.$toast("成功解绑!");
            this.unboundWechatDialogVisible = false;
            this.$store.dispatch("getMyInfo");
          } else {
            this.msg = res.msg;
            this.unboundWechatDialogVisible = false;
            this.unbindDialog = true;
          }
        });
      }
      if (this.bindType === 1) {
        this.$http.release_qq(this.$store.state.user.nickname).then(res => {
          if (res.code !== 600) {
            this.$toast("成功解绑!");
            this.unboundWechatDialogVisible = false;
            this.$store.dispatch("getMyInfo");
          } else {
            this.msg = res.msg;
            this.unboundWechatDialogVisible = false;
            this.unbindDialog = true;
          }
        });
      }
    },
    userInfoMarke() {
      this.editPortrait = true;
    },
    chooseResetType(type) {
      this.chooseResetTypeVisible = false;
      if (type === "mobile") {
        this.showPhoneDialog = true;
        // this.resetMobileForm1.mobile = this.$store.state.user.mobile
      } else {
        this.resetPwdDialogVisible = true;
      }
    },
    /* 修改用户名 */
    changeUserInfo() {
      this.$http.change_myinfo(this.changeUserInfoForm).then(res => {
        this.editPortrait = false;
        this.changeUserInfoForm.nickname = "";
        this.$store.dispatch("getMyInfo");
      });
    },
    closeQQDialog() {
      this.isBindQQ = false;
      clearInterval(this.listeningQQCallbackTimer);
    }
  }
}
</script>
<style lang="scss" scoped>
.usercenter{
  margin-top: -80px;
  height: 937px;
  img{
    margin: 0 auto;
  }
}
.userBox {
  
  overflow: hidden;
  background: rgba(7, 12, 21, 0.5);
  width: 980px;
  height: 350px;
  border-radius: 10px;
  margin: 0 auto;
  font-size: 16px;
  margin-top: 10px;
  // margin-top: 300px;
}
.userBox .status {
  font-size: 16px;
  margin-top: 20px;
  text-align: center;
}
.userBox .statusBtn {
  margin-top: 20px;
  background: #22c8cc;
  display: inline-block;
  border-radius: 29px;
  padding: 5px 20px;
  cursor: pointer;
}
.userBox .userDetail {
  text-align: center;
  float: left;
  color: #ffffff;
  width: 200px;
  margin: 80px 22px;
}
.detailOperate {
  width: 615px;
  overflow: hidden;
  position: relative;
  min-height: 380px;
  background: #202a38;
  border-radius: 10px; /* position: fixed; */ /* top:32%; */ /* left:36.5%; */
  z-index: 9999;
  color: #ffffff;
  text-align: center;
}
.detailOperate .operateTitle {
  font-size: 24px;
  line-height: 24px;
  margin-top: 50px;
  margin-bottom: 30px;
  text-align: center;
}
.detailOperatebtn {
  display: block;
  background: #22c8cc;
  width: 300px;
  line-height: 42px;
  border-radius: 24px;
  font-size: 18px;
  cursor: pointer;
  margin:0 auto;
  
  text-align: center;
}
.resetPass{
margin-bottom: 30px;
}
.detailOperateCloseBtn {
  margin: 15px 0;
  display: inline-block;
  background: #121621;
  width: 300px;
  line-height: 42px;
  border-radius: 24px;
  font-size: 18px;
  cursor: pointer; /* margin: 50px 0; */
  margin-top: 20px;
  margin-bottom: 50px;
  text-align: center;
}
.resetInput {
  width: 180px;
  border: 2px solid #c5c5c5;
  padding: 10px 20px;
  margin: 15px 0;
  font-size: 16px;
  color: #ffffff;
  background: #121621;
  border-radius: 30px;
}
.detailOperate .title-top {
  font-size: 24px;
  margin-top: 60px;
}
.detailOperate .login-input {
  margin: 31px 0;
  font-size: 0;
}
.detailOperate input {
  color: #ffffff;
  width: 280px;
  line-height: 40px;
  border-radius: 24px;
  height: 40px;
  border: 1px solid #5c5c5c;
  padding-left: 18px; /* margin-right: 10px; */
  background: #121621;
  font-size: 16px;
}
.detailOperate .login-btn {
  cursor: pointer;
  width: 300px;
  line-height: 40px;
  font-size: 18px;
  border-radius: 24px;
  background: #22c8cc;
  border: none;
  color: #ffffff;
}
.detailOperate .comfirm-btn {
  cursor: pointer;
  width: 300px;
  line-height: 40px;
  font-size: 18px;
  border-radius: 30px;
  background: #22c8cc;
  border: none;
  color: #ffffff;
}
.detailOperate .getCode {
  vertical-align: bottom;
  /*padding: 7px 16px;*/
  width: 115px;
  font-size: 14px;
  display: inline-block;
  border: 1px solid #36e1e5;
  border-radius: 23px;
  line-height: 40px;
  cursor: pointer;
  color: #36e1e5;
}
.detailOperate .codeNum {
  width: 150px;
  margin-right: 13px;
}
.detailOperate #weixinQrcode {
  margin-top: 25px;
}
.detailOperate .title-mid {
  font-size: 24px;
  line-height: 40px;
  margin: 155px 55px; /* vertical-align: middle; */
}
.detailOperate .closeBtn {
  position: absolute;
  top: 15px;
  right: 15px;
  cursor: pointer; /* float: right; */
}
.set_dialog .bind_setting{
    position: relative;
    width: 100%;
    height:340px;
    margin: 0 auto;
    .img{
      width: 180px;
     
      margin: 0 auto;
      margin-top: 40px;
    }
    iframe{
      width: 180px;
      height: 200px;
    }
}
</style>
<style lang="scss">
.unbind_dialog {
    padding-top: 30px;
    width: 100% !important;
    p {
      padding-top: 0;
      padding-bottom: 18px;
      text-align: center;
      &:nth-of-type(1) {
        font-size: 18px;
      }
      &:nth-of-type(2) {
        width: 222px;
        margin: 0 auto;
        padding-top: 67px;
      }
    }
    .bind_info {
      p {
        padding-top: 10px;
        font-size: 14px;
      }
      .btn {
        @include size(150px, 43px);
        line-height: 43px;
        margin: 0 auto;
        background: rgba(49, 171, 218, 1);
        border-radius: 22px;
        padding: 0;
        margin-top: 50px;
        cursor: pointer;
      }
      .edit {
        background: rgba(76, 115, 146, 1);
        margin-top: 20px;
        color: #9e9e9e;
        cursor: not-allowed;
      }
      .edid_active {
        margin-top: 20px;
        cursor: pointer;
      }
    }
    img {
      margin: 0 auto;
      @include size(120px, 120px);
      border-radius: 100%;
    }
    .el-input__inner {
      margin-top: 18px;
      @include size(216px, 43px);
      background: rgba(42, 68, 90, 1);
      border-radius: 22px;
      border: 2px solid rgba(221, 221, 221, 1);
    }
  }
</style>